module.exports = {
    title: "Company Size",
    crud: {
        create: "Create Company Size",
        edit: "Edit Company Size",
        view: "View Company Size",
    },
    table: {
        from: "From",
        to: "To",
        title: "Title",
        isActive: 'Active',
    },
    form: {
        from: "From",
        to: "To",
        title: "Title",
        isActive: 'Active',
    },
    validation: {
        required: {
            from: 'From is required',
            to: 'To is required',
            title: 'title is required',
        },
        minLength: {
            title: 'title must have at least',
            from: 'from must have at least',
            to: 'to must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
